import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizedDate',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(value: any, pattern = 'mediumDate'): any {
        const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);

        if (pattern === 'standard') {
            pattern = this.translateService.currentLang === 'en' ? 'MMM d, y, h:mm a' : 'd.MMM.y, HH:mm';
        }

        return datePipe.transform(value, pattern);
    }
}
